import { useEffect } from 'react'
import type { JSX } from 'react'
import { useLocation } from 'react-router-dom'

import { MobileSettingsDrawer } from './MobileSettingsDrawer'
import { MobileSidebarProvider, useMobileSidebar } from './MobileSidebarContext'
import { MobileSidebarDrawer } from './MobileSidebarDrawer'
import { MobileTopbar } from './MobileTopbar'
import { OrganizationSwitcherProvider } from '../OrganizationSwitcher/OrganizationSwitcherContext'

/**
 * Inner component that handles closing menu on navigation.
 * Needs to be inside MobileSidebarProvider to access context.
 */
function MobileSidebarContent(): JSX.Element {
  const location = useLocation()
  const { closeAll } = useMobileSidebar()

  // Close menu when navigating to a new page
  useEffect(() => {
    closeAll()
  }, [location.pathname, closeAll])

  return (
    <OrganizationSwitcherProvider>
      <MobileTopbar />
      <MobileSidebarDrawer />
      <MobileSettingsDrawer />
    </OrganizationSwitcherProvider>
  )
}

/**
 * Mobile version of the MainSidebar component.
 * Renders a topbar with hamburger menu and the navigation drawer.
 * Used on screens < 768px (useIsMobileScreenSize breakpoint).
 */
export function MobileSidebar(): JSX.Element {
  return (
    <MobileSidebarProvider>
      <MobileSidebarContent />
    </MobileSidebarProvider>
  )
}
